import { useState } from 'react';
import { homeFaqs } from '@/mocks/home';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12 md:mb-14">
          <span className="inline-block px-4 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            关于亚洲在线的常见疑问解答
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            快速了解亚洲在线的服务与功能
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {homeFaqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-950 pr-2">
                  {faq.q}
                </h3>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                  openIndex === index ? 'bg-primary-500 text-white rotate-45' : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5 px-5 md:px-6' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}